'use client';

import * as React from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";

import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label="Toggle theme"
      className="relative h-9 w-9 rounded-full p-0"
    >
      <motion.div 
        initial={false}
        animate={{ rotate: isDark ? 0 : 180 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <Sun 
          className={`h-5 w-5 transition-all ${isDark ? 'opacity-0 scale-50' : 'opacity-100 scale-100 text-foreground'}`} 
        />
        <Moon 
          className={`absolute h-5 w-5 transition-all ${isDark ? 'opacity-100 scale-100 text-foreground' : 'opacity-0 scale-50'}`} 
        />
      </motion.div>
    </Button>
  );
} 